/**
 * Directive: emailResources
 */
angular.module('acme.common.directive.emailResources', [])
.directive('emailResources', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/emailResources/emailResources.tpl.html',
      scope: {
        type: '=',
        list: '=',
        hideList: '=',
        sendEmail: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.emailResources = {

          hideList: false,
          sendEmail: true,

          init: function() {
            this.hideList = !!$scope.hideList;
            this.sendEmail = $scope.sendEmail;

            $scope.$on('$destroy', $scope.$watch('emailResources.sendEmail', this.onSendEmailUpdate));
          },

          showNotification: function () {
            return ( !this.isNever() && (this.hideList || $scope.list.length) );
          },

          isNever: function() {
            return ($scope.type === 'never');
          },

          isSingleEmail: function() {
            var r = false;
            if ($scope.list instanceof Array && $scope.list.length === 1) {
              r = true;
            }

            if (typeof $scope.list === 'string') {
              r = true;
            }

            return r;
          },

          isMultipleEmails: function() {
            var r = false;
            if ($scope.list instanceof Array && $scope.list.length > 1) {
              r = true;
            }
            return r;
          },

          getEmail: function() {
            var list = [$scope.list],
                result = [].concat.apply([], list);

            return result[0] || '';
          },

          getEmailsQuantity: function() {
            return ($scope.list instanceof Array) ? $scope.list.length : 0;
          },

          onSendEmailUpdate: function(n, o) {
            if (n !== o) {
              $scope.sendEmail = n;
            }
          }
        };

        $scope.emailResources.init();

      }]

    };

}]);